import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"back_folder_lecture",
    list_id:"back_folder_lec_manage",
    x_column_list_arr:[
      {"key":"a_name","name":"폴더명","width":"180","is_show":"1"},
      {"key":"row_view_lecture_cnt","name":"수업","width":"80","is_show":"1"},
      {"key":"row_view_stu_cnt","name":"학생","width":"80","is_show":"1"},
      {"key":"a_create_date","name":"생성일","width":"160","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':10,
      'order_id':'a_seq DESC',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;